import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

export var FormError =
/*#__PURE__*/
function (_Error) {
  _inherits(FormError, _Error);

  var _super = _createSuper2(FormError);

  function FormError(message, name, value) {
    var _this;

    _classCallCheck(this, FormError);

    _this = _super.call(this);
    _this.value = void 0;
    _this.message = message;
    _this.name = name || '';
    _this.value = value;
    return _this;
  }

  return FormError;
}(
/*#__PURE__*/
_wrapNativeSuper(Error));
export function wrapFormError(error) {
  if (error instanceof Error) {
    return new FormError(error.message);
  }

  if (Array.isArray(error)) {
    return error.map(function (e) {
      return wrapFormError(e);
    });
  }

  return error;
}
export var promiseAll = function promiseAll(ops) {
  var isForm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return new Promise(function (resolve, reject) {
    Promise.all(ops).then(function (res) {
      var error = res.find(function (r) {
        return r !== true;
      });
      if (error) reject(error);else resolve(true);
    })["catch"](function (e) {
      reject(isForm ? wrapFormError(e) : e);
    });
  });
};
export var isSameError = function isSameError(a, b) {
  if (a === b) return true;

  if (a instanceof Error && b instanceof Error) {
    return a.message === b.message;
  }

  return a === b;
};